.ship-by-date-label {
  margin: 8px 0;
}

.set-ship-by-date {
  width: 50%;
  margin-left: 23px;
  margin-bottom: 16px;
}

.set-ship-by-days {
  margin-left: 23px;
  display: flex;
  align-items: center;
}

.days-input {
  width: 15%;
}

.days-input-label {
  margin-left: 5px;
  font-size: 14px;
}
